import { render, staticRenderFns } from "./c-percents-field.vue?vue&type=template&id=19a1e166&"
import script from "./c-percents-field.vue?vue&type=script&lang=js&"
export * from "./c-percents-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports